const renameDuplicateFile = (file: File): File => {
  const fileNameSegments = file.name.split('.');
  fileNameSegments[fileNameSegments.length - 2] += ' (1)';
  return new File([file], fileNameSegments.join('.'), { type: file.type });
};

export default renameDuplicateFile;
